import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { IconType } from 'react-icons';

interface ChakraIconProps extends Omit<BoxProps, 'as'> {
  icon: IconType;
  size?: string | number;
  color?: string;
}

// This component wraps react-icons for use with Chakra UI
// Using type assertion to bypass TypeScript errors
const ChakraIcon: React.FC<ChakraIconProps> = ({ icon, size = '24px', color, ...props }) => {
  const boxSize = typeof size === 'number' ? `${size}px` : size;
  
  // Use type assertion to tell TypeScript that this is safe
  const IconComponent = icon as any;
  
  return (
    <Box display="inline-block" {...props}>
      <IconComponent size={boxSize} color={color} />
    </Box>
  );
};

export default ChakraIcon;
